import { useState } from "react";

const faqs = [
  {
    question: "1. What is Jopo?",
    answer:
      "Jopo Delivery is a delivery platform that helps you send and receive packages quickly and reliably. Whether it's within your city or across regions, Jopo connects you with trusted drivers to handle your deliveries.",
  },
  {
    question: "2. How do I place an order?",
    answer: `To place an order:
- Open the Jopo delivery app
- Enter pickup and drop-off locations
- Add parcel details (size, type, instructions)
- Confirm pricing
- Place your order

A driver will be assigned immediately.`,
  },
  {
    question: "3. How is the delivery cost calculated?",
    answer: `Pricing is based on:
- Distance between pickup and drop-off
- Parcel size/weight
- Delivery type (Normal, Urgent)
- Demand at the time

You will always see the price before confirming your order.`,
  },
  {
    question: "4. Can I track my delivery?",
    answer: `Yes. Jopo delivery provides real-time tracking:
- See your driver's live location
- Track delivery status updates
- Get notifications from pickup to drop-off`,
  },
  {
    question: "5. What payment methods are available?",
    answer: `You can pay using:
- Mobile money (Bank transfer, M-Pesa, Airtel Money, etc.)
- Wallet (in-app balance)
- Cash on delivery (if enabled)`,
  },
  {
    question: "6. What happens if my delivery is delayed?",
    answer: `If your delivery is delayed:
- You'll receive a notification
- Our support team monitors delays
- You can contact support directly from the app

We work to resolve issues quickly.`,
  },
  {
    question: "7. Can I cancel an order?",
    answer: `Yes, you can cancel:
- Before a driver is assigned → No charge
- After driver assignment → Cancellation fee may apply`,
  },
  {
    question: "8. What items are not allowed?",
    answer: `Prohibited items include:
- Illegal goods
- Dangerous or hazardous materials
- Perishable items (unless supported)
- High-value items without insurance`,
  },
  {
    question: "9. What if my parcel is lost or damaged?",
    answer: `Jopo takes parcel safety seriously:
- Report the issue via the app
- Investigation will be conducted
- Compensation may apply based on policy`,
  },
  {
    question: "10. Can I schedule a delivery?",
    answer: `Yes. You can:
- Request immediate delivery
- Schedule delivery for a later time`,
  },
  {
    question: "11. How do I contact customer support?",
    answer: `You can reach support via:
- In-app chat
- Phone support
- Email

Support is available to assist you anytime.`,
  },
  {
    question: "12. Can I send multiple parcels at once?",
    answer: `Yes, Jopo delivery supports:
- Bulk delivery
- Multi-drop deliveries

This is ideal for businesses.`,
  },
  {
    question: "13. Do drivers verify deliveries?",
    answer: `Yes:
- OTP or signature confirmation
- Photo proof (optional)
- Status updates upon delivery`,
  },
  {
    question: "14. Is my personal information safe?",
    answer: `Yes. Jopo delivery ensures:
- Secure authentication
- Data encryption
- Privacy protection`,
  },
  {
    question: "15. Do you offer business accounts?",
    answer: `Yes. Businesses can:
- Access bulk delivery tools
- Get special pricing
- Use dashboards for tracking`,
  },
];

export default function CustomerFAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-orange-600 mb-6">
        Customer FAQs
      </h1>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-xl shadow-sm"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center p-4 text-left font-semibold text-green-700 hover:bg-green-50 rounded-xl"
            >
              {faq.question}
              <span className="text-orange-500 text-xl">
                {openIndex === index ? "-" : "+"}
              </span>
            </button>

            {openIndex === index && (
              <div className="p-4 pt-0 text-gray-700 whitespace-pre-line">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
